import { render, staticRenderFns } from "./TheJsonEditor.vue?vue&type=template&id=35edef56&scoped=true&"
import script from "./TheJsonEditor.vue?vue&type=script&lang=js&"
export * from "./TheJsonEditor.vue?vue&type=script&lang=js&"
import style0 from "./TheJsonEditor.vue?vue&type=style&index=0&id=35edef56&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35edef56",
  null
  
)

export default component.exports